module.exports = __webpack_public_path__ + "img/purple-booth-table-4.7543670c.png";